import { render, staticRenderFns } from "./RocketLeagueRecap2021.vue?vue&type=template&id=d4a8776a&scoped=true&"
import script from "./RocketLeagueRecap2021.vue?vue&type=script&lang=js&"
export * from "./RocketLeagueRecap2021.vue?vue&type=script&lang=js&"
import style0 from "./RocketLeagueRecap2021.vue?vue&type=style&index=0&id=d4a8776a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a8776a",
  null
  
)

export default component.exports